import React, { useEffect, useState } from 'react';
import { PAYMENT_MODE, PAYMENT_MODE_TEST } from '../../../utils/payments';

import s from './index.module.scss';

const PaymentModeWarning = () => {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    // Perform extra check on client side.
    // Payment mode can change on client side (e.g. when test mode is enabled
    // on production.
    // Related: https://nextjs.org/docs/messages/react-hydration-error
    setVisible(PAYMENT_MODE === PAYMENT_MODE_TEST);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={s['payment-mode-warning']}>
      <a href="https://cw2.readme.io/docs/payments" target="_blank" rel="noopener noreferrer">
        TEST MODE
      </a>
    </div>
  );
};

export default PaymentModeWarning;
